import { Modal } from 'react-bootstrap';
import logoImage from "../../assest/images/logo-img.png"
import whiteLogoImage from "../../assest/images/whitelogo.png";
const VerificationModal = ({
    show,
    handleClose,
    verify,
    verifyState,
    changeValueOtp,
    handlePaste,
    canResend, timer, resendOtp, formatTime
}) => {
    const { otp, error } = verifyState;
    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            className='verification-modal dark_common_modal'
        >
            {/* <Modal.Header closeButton>
                <Modal.Title>Modal title</Modal.Title>
            </Modal.Header> */}
            <Modal.Body>
                <div className="container">
                    <a href="javascript:void(0)" className='comLogo'><img src={logoImage} alt="logo-img" /></a>
                    <a href="javascript:void(0)" className='whitelogo'><img src={whiteLogoImage} alt="logo-img" /></a>
                    <h4>Security Verification <br /> Requirements</h4>
                    <h6>We have sent the verification code to your email</h6>
                </div>
                <form
                //  onSubmit={verify}
                >
                    <div className="getOtpBox">
                        <input
                            type="text"
                            className="commonInput"
                            id="otp"
                            name="otp"
                            value={otp}
                            onChange={changeValueOtp}
                            onPaste={handlePaste}
                            maxLength="6"
                        />
                        {/* <a className="comYellowa" href="javascript:void(0)" 
                                onClick={(e) => handlePasteButtonClick(e)}
                                >PASTE</a> */}

                        {error && error.otp && <span className="cus-err" style={{ top: "100%" }}>{error.otp}</span>}
                    </div>
                    <div className="register">
                        <p>You did not receive the code
                            {/* <a className="comYellowa" href="javascript:void(0)" >Resend</a> */}
                            {canResend ? (
                                <a className="comYellowa" href="javascript:void(0)" onClick={() => resendOtp()}>Resend</a>
                            ) : (
                                <span className="disabled">&nbsp;Resend in {formatTime(timer)}</span>
                            )}
                        </p>
                    </div>
                </form>

            </Modal.Body>
            {/* <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <button variant="primary"  onClick={verify}>Understood</button>
            </Modal.Footer> */}
        </Modal >
    )
}
export default VerificationModal